import type { FacetSelection } from "./types";

export const NO_FACET_CONSTRAINT: FacetSelection = { kept: [], dropped: [] };

export const constrainsNothing = (selection: FacetSelection): boolean =>
    selection.kept.length === 0 && selection.dropped.length === 0;

export const isFacetValueChecked = (selection: FacetSelection, value: string): boolean =>
    !selection.dropped.includes(value) && (selection.kept.length === 0 || selection.kept.includes(value));

const coversDomain = (values: string[], domain: string[] | undefined): boolean =>
    domain !== undefined && domain.length > 0 && domain.every((candidate) => values.includes(candidate));

const withoutValue = (values: string[], value: string): string[] => values.filter((candidate) => candidate !== value);

const normalized = (selection: FacetSelection, domain: string[] | undefined): FacetSelection => {
    const kept = coversDomain(selection.kept, domain) ? [] : selection.kept;
    const dropped = coversDomain(selection.dropped, domain) ? [] : selection.dropped;

    return kept.length === 0 && dropped.length === 0 ? NO_FACET_CONSTRAINT : { kept, dropped };
};

const including = (selection: FacetSelection, value: string): FacetSelection => ({
    kept: selection.kept.length === 0 || selection.kept.includes(value) ? selection.kept : [...selection.kept, value],
    dropped: withoutValue(selection.dropped, value),
});

const excluding = (selection: FacetSelection, value: string): FacetSelection =>
    selection.kept.includes(value) ?
        { kept: withoutValue(selection.kept, value), dropped: selection.dropped }
    :   { kept: selection.kept, dropped: [...selection.dropped, value] };

export const toggleFacetValue = (selection: FacetSelection, value: string, domain?: string[]): FacetSelection =>
    normalized(
        isFacetValueChecked(selection, value) ? excluding(selection, value) : including(selection, value),
        domain,
    );

export const selectOnlyFacetValue = (value: string, domain?: string[]): FacetSelection =>
    normalized({ kept: [value], dropped: [] }, domain);
